import { StandardEvents } from '@shopify/events';

function syncHeaderCartCount(itemCount) {
  if (!Number.isFinite(itemCount) || itemCount < 0) return;

  document.querySelectorAll('.ds-cart-trigger__count').forEach((headerBadge) => {
    headerBadge.textContent = String(itemCount);
    headerBadge.classList.toggle('is-empty', itemCount === 0);
  });
}

document.querySelectorAll('[data-ds-cart-open]').forEach((cartTrigger) => {
  cartTrigger.addEventListener('click', (event) => {
    const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
    if (!cartDrawer || typeof cartDrawer.open !== 'function') return;

    event.preventDefault();
    cartDrawer.open();
  });
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      const itemCount = cart?.totalQuantity ?? detail?.itemCount;
      syncHeaderCartCount(Number(itemCount));
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[deepsweep-cart-drawer] Cart count update failed:', error);
    });
});
